module.exports = __webpack_public_path__ + "media/images/badge/coppa-italia-finalista_secondary-215fa46a7a79f524d70eeb22981f2c6c.png";